import { render, staticRenderFns } from "./SubPantalla2.vue?vue&type=template&id=4f53cb97&"
import script from "./SubPantalla2.vue?vue&type=script&lang=js&"
export * from "./SubPantalla2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports